import React from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Navigate } from "react-router-dom";
import CurrentUser from "../queries/CurrentUser";

const RequireAuth = (WrappedComponent) => {
  const AuthenticatedComponent = (props) => {
    const { loading, error, data } = useQuery(CurrentUser);

    const location = useLocation();

    console.log("location 2: ", location);

    if (loading) return null;
    if (error) {
      console.log("error:");
      console.log(error);
      return <p>Something Went Wrong...</p>;
    }

    if (typeof data.currentUser === "undefined" || data.currentUser === null) {
      console.log("navigating to login, current user not found.");
      return <Navigate to="/login" replace={true} />;
    } else if (data.currentUser.role === "admin") {
      console.log("navigating to admin dashboard, current user is an admin.");
      return <Navigate to="/admin/dashboard" replace={true} />;
    } else if (data.currentUser.role === "report_viewer") {
      console.log(
        "navigating to reports dashboard, current user is a report viewer.",
      );
      return <Navigate to="/admin/reports" replace={true} />;
    } else if (data.currentUser.role === "user") {
      console.log("navigating to wrapped component since authorized..");
      return <WrappedComponent currentUser={data.currentUser} />;
    }
  };

  return <AuthenticatedComponent />;
};

export default RequireAuth;
